<div class="BiBoxR mb-3">
<p-accordion value="0">
    <p-accordion-panel value="0">
        <p-accordion-header><div class="BiMoTtl">Favourite Reports</div></p-accordion-header>
            <p-accordion-content>
                <div>
                    @if(Items.length>0) {
                        @for(item of Items;track item) {
                            <div class="flex mb-3 favCls">
                                <div class="mr-2 flex flex-column align-items-center">
                                    <div><i (click)=toggleFavourite(item) class="pi pi-star-fill" [ngClass]="item.isFavourite ? 'strFCl' : 'strFGr'"></i></div>
                                    <div class="moveIcon mt-2 hidden"><img src="assets/images/v-dotts.svg" alt=""></div>
                                </div>
                                <div>
                                    <div class="mb-1">
                                        <a class="BlTxt" *ngIf="item.reportFrom == 2" routerLink="/report-details/{{item?.moduleId}}/{{item?.savedReportId}}">{{item?.reportName}}</a>
                                        <a class="BlTxt" *ngIf="item.reportFrom == 1" routerLink="/report-details/{{item?.moduleId}}/0">{{item?.reportName}}</a>
                                    </div>
                                    @if(item?.reportDesc){
                                        <div class="mb-1 sbTxt" pTooltip="{{item?.reportDesc}}" tooltipPosition="top">{{item?.reportDesc?.length > 75 ? (item?.reportDesc | slice:0:75) + '...' : item?.reportDesc}}</div>
                                    }
                                </div>
                            </div>
                        }
                    } @else {
                        <div class="flex mb-3 favCls">No Reports Found.</div>
                    }
                </div>
            </p-accordion-content>
    </p-accordion-panel> 
</p-accordion>


</div>
 